import { MinzeElement, EventListeners, Reactive } from 'minze'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { copyTextToClipboard } from '../../modules/utils'
import { Font } from '../../constants'
import { Routing } from '../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'notLoggedInPopup', {
  title: 'Oups! Pas encore de compte?',
  text: "Pour profiter des fonctionnalités telles qu'ajouter un artiste, un événement ou un lieu dans vos favoris ou signaler un problème, vous devez être connecté à votre compte. C'est simple et facile de le faire!",
  signIn: 'Me connecter',
  signUp: 'Créer mon compte',
})

Locale.getInstance().registerKeySet('en', 'notLoggedInPopup', {
  title: "Oops! Still don't have an account?",
  text: "To take advantage of features such as adding an artist, event or location to your favorites, or reporting a problem, you need to be logged in to your account. It's simple and easy to do!",
  signIn: 'Sign in',
  signUp: 'Sign up',
})

export interface LvcNotLoggedInPopup {}

export class LvcNotLoggedInPopup extends MinzeElement {
  reactive: Reactive = [
    ['linkCopied', false],
    ['isDesktop', true],
  ]
  language = MainModule.getInstance().getLang()
  handleSignIn = () => {
    MainModule.getInstance().getRouting().goTo(Routing.ROUTES[this.language].login)
  }
  handleSignUp = () => {
    this.remove()
    window.open(Routing.ROUTES[this.language].signup, '_blank')
  }

  html() {
    return `
    <lvc-closeable-modal id="modal" max-width="600px" no-close-button modal-title="${Locale.getKey('notLoggedInPopup.title')}">
      <div class="content">
        <div class="text">${Locale.getKey('notLoggedInPopup.text')}</div>
        <div class="buttons-wrapper">
          <lvc-button id="goToSignIn" enable-hover-box-shadow border="1px solid #1E007D;" theme="transparent">${Locale.getKey(
            'notLoggedInPopup.signIn'
          )}</lvc-button>
          <lvc-button id="goToSignUp" enable-hover-box-shadow>${Locale.getKey('notLoggedInPopup.signUp')}</lvc-button>
        <div>
      </div>

    </lvc-closeable-modal>
    `
  }

  css = () => `
    lvc-closeable-modal::part(title) {
      font-weight: ${Font.weight.extraBold};
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
    lvc-closeable-modal::part(header) {
      height: auto;
      display: block;
    }
    .content {
      color: #1E007D;
    }
    .text {
      font-size: 1rem;
    }
    .buttons-wrapper{
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      margin-top: 2rem;
    }
    @media only screen and (max-width: 768px) {
      .buttons-wrapper {
        justify-content: center;
        gap: 0.5rem;
      }
    }
    @media only screen and (max-width: 576px) {
      .buttons-wrapper {
        flex-direction: column;
        align-items: stretch;
        margin-top: 1.5rem;
      }
      .text {
        font-size: 0.875rem;
      }
      lvc-closeable-modal::part(title) {
        font-weight: ${Font.weight.extraBold};
        font-size: 1.25rem;
        margin-bottom: 1rem;
      }
    }
  `

  eventListeners: EventListeners = [
    ['#goToSignIn', 'click', this.handleSignIn],
    ['#goToSignUp', 'click', this.handleSignUp],
  ]
}
